export const IsBetaWindow = () => location.hostname.split(".")[0] === "web-beta";
export const IsDevWindow = () => location.hostname.split(".")[0] === "web-dev" || location.hostname === "localhost";
export const IsProductionWindow = () => location.hostname.split(".")[0] === "web";
export const getSubDomain = () =>
	location.hostname === "localhost"
		? true
		: IsDevWindow()
			? "web-dev"
			: IsBetaWindow()
				? "web-beta"
				: IsProductionWindow()
					? "web"
					: null;
